import React from 'react'
import classNames from 'classnames'
import s from './Faq.less'

const FaqContainer = ({ children, className, impressionDataTag }) => (
  <div
    itemScope
    itemType="https://schema.org/FAQPage"
    className={classNames(s.root, className, impressionDataTag && 'pub-impression-event')}
    data-tag={impressionDataTag}
  >
    {children}
  </div>
)

export default FaqContainer
